export default {
  redirectAfterLogin: 'redirectAfterLogin',
};
